import React from 'react'

import { usePlaid } from './PlaidContext'
import PlaidLogo from '@mortgage-pos/ui/assets/plaid.svg'
import ShieldIcon from '@mortgage-pos/ui/assets/plaid-shield.svg'
import HouseIcon from '@mortgage-pos/ui/assets/plaid-house.svg'
import SpeedometerIcon from '@mortgage-pos/ui/assets/plaid-speedometer.svg'
import Button, { ButtonVariants } from '@mortgage-pos/ui/components/Button'
import { useStoreActions } from '@mortgage-pos/ui/store'

export const PlaidOption = () => {
  const { setUsePlaidUpload } = usePlaid()
  const { elementClicked } = useStoreActions((state) => state.tracking)

  const buttonText = 'Link your bank accounts'

  const linkBankAccountsHandler = () => {
    setUsePlaidUpload(true)
    elementClicked({
      elementType: 'Button',
      location: 'Plaid Screen',
      actionOutcome: 'Enter Plaid Bank Account Linking',
      text: buttonText,
    })
  }

  return (
    <div className="plaid-assets__content">
      <div className="plaid-assets__logo plaid-assets__mb-24">
        <img src={PlaidLogo} alt="PlaidLogo" height={36} />
      </div>
      <div className="plaid-assets__header">
        <p className="plaid-assets__title">Recommended</p>
        <p className="plaid-assets__heading">Link your bank accounts</p>
        <p className="plaid-assets__description">
          Speed up the mortgage process by verifying your assets via Plaid.
        </p>
      </div>

      <div className="plaid-assets__benefits">
        <div className="plaid-assets__benefit">
          <img src={SpeedometerIcon} alt="Speedometer Icon" />
          <span>Upload fewer documents</span>
        </div>
        <div className="plaid-assets__benefit">
          <img src={HouseIcon} alt="House Icon" />
          <span>Enjoy faster processing time</span>
        </div>
        <div className="plaid-assets__benefit">
          <img src={ShieldIcon} alt="Shield Icon" />
          <span>Peace of mind with 256-bit security</span>
        </div>
      </div>

      <Button
        className="plaid-assets__cta-button"
        onClick={linkBankAccountsHandler}
        variant={ButtonVariants.next}
        content={buttonText}
      />
    </div>
  )
}

export default PlaidOption
